import service from "../../../../../plugin/axios";

export const URL = "/admin/menu";

export function getLeftMenu() {
  return service.get(URL + "/getLeftMenu");
}
